/**
 * Category Hooks
 *
 * Custom React hooks for category-related functionality
 */

export { useSearchCategories } from './useSearchCategories';
export type { UseSearchCategoriesReturn } from './useSearchCategories';

export { usePopularCategories } from './usePopularCategories';
export type {
  UsePopularCategoriesParams,
  UsePopularCategoriesReturn,
} from './usePopularCategories';

export { usePopularSubcategories } from './usePopularSubcategories';
export type {
  UsePopularSubcategoriesParams,
  UsePopularSubcategoriesReturn,
} from './usePopularSubcategories';

export { useAllCategories } from './useAllCategories';
export type {
  UseAllCategoriesParams,
  UseAllCategoriesReturn,
} from './useAllCategories';

export { useSearchHistory } from './useSearchHistory';
export type {
  SearchHistoryEntry,
  UseSearchHistoryReturn,
} from './useSearchHistory';
